import { notificationReducerActions } from "../../_services/store";
import { notificationService } from "../notification.service";

export const getResponseNotification = (notificationUUID) => {
    return async (dispatch) => {
        dispatch(notificationReducerActions.getResponseNotificationRequest());
        try {
            let response = await notificationService.getResponseNotification(notificationUUID);

            dispatch(notificationReducerActions.getResponseNotificationSuccess(response));
        } catch (error) {
            if (error.message) {
                dispatch(notificationReducerActions.getResponseNotificationFailure(error.message));
            } else if (error.errorMessage) {
                dispatch(notificationReducerActions.getResponseNotificationFailure(error.errorMessage));
            } else {
                dispatch(notificationReducerActions.getResponseNotificationFailure(error));
            }
        }
    };
};

export const getPublicResponseNotification = (notificationUUID) => {
    return async (dispatch) => {
        dispatch(notificationReducerActions.getResponseNotificationRequest());
        try {
            let response = await notificationService.getPublicResponseNotification(notificationUUID);
            dispatch(notificationReducerActions.getResponseNotificationSuccess(response));
        } catch (error) {
            //  We will not display error notification on public routes.
            dispatch(notificationReducerActions.getPublicResponseNotificationFailure());
        }
    };
};

export const getPlatformNotifications = (params) => {
    return async (dispatch) => {
        dispatch(notificationReducerActions.getPlatformNotificationsRequest());
        try {
            let response = await notificationService.getPlatformNotifications(params);
            dispatch(notificationReducerActions.getPlatformNotificationsSuccess(response));
        } catch (error) {
            //  We will not display error notification on public routes.
            dispatch(notificationReducerActions.getPlatformNotificationsFailure());
        }
    };
};

export const dismissPlatformNotification = (notificationUUID) => {
    return async (dispatch) => {
        dispatch(notificationReducerActions.dismissPlatformNotificationRequest(notificationUUID));
        try {
            let response = await notificationService.dismissPlatformNotification(notificationUUID);
            dispatch(notificationReducerActions.dismissPlatformNotificationSuccess(response));
        } catch (error) {
            //  We will not display error notification on public routes.
            dispatch(notificationReducerActions.dismissPlatformNotificationFailure());
        }
    };
};
